/*
 * Main Analytics File

   This is where any basic, non-product specific functions pertaining
   to analytics should go
 */

/**
 * Creates a key-value pair of the given parameters and pushes
 * it to the Google Tag Manager (GTM) datalayer
 * @param {String} key the key/name of the parameter
 * @param {*} value the value to set
 */
export const pushToDataLayer = (key, value) => {
  let data = {}
  data[key] = value
  if (window.dataLayer) {
    window.dataLayer.push(data)
  }
}

/**
 * Pushes data into the Google Tag Manager (GTM) datalayer
 * @param {*} data data to add to datalayer
 */
window.pushDataToDataLayer = function (data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}

/**
 * Pushes an event into the Google Tag Manager (GTM) datalayer
 * @param {*} data data to add to datalayer
 */
window.pushEventToDataLayer = function (data) {
  window.pushDataToDataLayer({
    event: data,
  })
}

/**
 * Pushes data into the Google Tag Manager (GTM) datalayer
 * @param {*} data data to add to datalayer
 */
export const pushDataToDataLayer = (data) => {
  window.pushDataToDataLayer(data)
}

/**
 * Strips any html tags before pushing to datalayer
 * @param {*} htmlMessage Message with HTML tags to strip
 */
export const stripHTMLTagsFromError = (htmlMessage) => {
  if (htmlMessage === null || htmlMessage === '') {
    return htmlMessage
  } else {
    return htmlMessage.replace(/<[^>]*>/g, '')
  }
}
